import dayjs from 'dayjs';
import { useTranslation } from '../../hooks/useTranslation';
import { isNil } from 'lodash';

export const formatEstimatedTimeOn = (estimatedTimeOn?: string | null) => {
  const { t } = useTranslation();

  if (isNil(estimatedTimeOn)) {
    return t('OUTAGE_ETO_UNKNOWN');
  }
  const estimatedTimeOnDayJs = dayjs(
    estimatedTimeOn.replace('p.m.', 'PM').replace('a.m.', 'AM'),
    'MMMM D, YYYY h:mm a',
  );
  const estimatedTimeOnFormatted = estimatedTimeOnDayJs.isValid()
    ? estimatedTimeOnDayJs
        .format('MMM D, h:mm a')
        .replace('am', 'AM')
        .replace('pm', 'PM')
    : t('OUTAGE_ETO_UNKNOWN');

  return estimatedTimeOnFormatted;
};

export const hideOutageByZipCode = false;
